/** Supporting copy shown under onboarding headings (banner invite and every survey question). */
export const ONBOARDING_SUBTITLE = 'Improve AI responses by sharing details about yourself';

/** Title on the welcome-panel invite shown before the user starts the onboarding survey. */
export const ONBOARDING_INTRO_TITLE = 'Tell us about your role';
